
const one ="https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Scholarships/schone.webp"
const two="https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Scholarships/schtwo.webp"
const three="https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Scholarships/schthree.webp"
const four ="https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Scholarships/schfour.webp"
const five="https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Scholarships/schfive.webp"
const six="https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Scholarships/schsix.webp"
const seven="https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Scholarships/schseven.webp"
const eight ="https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Scholarships/scheight.webp"
const nine="https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Scholarships/schnine.webp"
const Scholar_info=[
    {
        id:"1",
        schbg:one,
        IncLimit:"2,50,000",
        schamt:"8000",
    },
    {
        id:"2",
        schbg:two,
        IncLimit:"2,50,000",
        schamt:"17000",
    },
    {
        id:"3",
        schbg:three,
        IncLimit:"2,50,000",
        schamt:"8000",
        schterms1:"ONLY SC/ST HOSTEL STUDENTS"
    },
    {
        id:"4",
        schbg:four,
        IncLimit:"2,50,000",
        schamt:"10000",
        schterms1:"ONLY MINIORITY COMMUNITY STUDENTS"
    },
    {
        id:"5",
        schbg:five,
        IncLimit:"8,00,000",
        schamt:"50000",
        schterms1:"ONLY GIRL STUDENTS"
    },
    {
        id:"6",
        schbg:six,
        IncLimit:"8,00,000",
        schamt:"50000",
        schterms1:"PG STUDENTS"
    },
    {
        id:"7",
        schbg:seven,
        IncLimit:"8,00,000",
        schamt:"50000",
        schterms1:"1) ORPHAN",
        schterms2:"2) EITHER OR BOTH PARENTS DIED DUE TO COVID 19",
        schterms3:"3) WARDS OF ARMED FORCES AND CENTRAL PARAMILITARY FORCES MARTYRED IN ACTION (SHAHEED)"
    },
    {
        id:"8",
        schbg:eight,
        IncLimit:"4,00,000",
        schamt:"12000",
        schterms1:"ALL STUDENTS CAN BE APPLIED"
    },
    {
        id:"9",
        schbg:nine,
        IncLimit:"-",
        schamt:"MONTHLY 1000 RUPEES",
        schterms1:"1) 6TH TO 12TH WHO STUDITED GOVT SCHOOL",
        schterms2:"2) ONLY GIRL STUDENTS"
    },
]

export {Scholar_info};